export default __webpack_public_path__ + "static/media/15_Connect-with-whanau_Share.8f4d9394.jpg";